import { API_ENDPOINTS, createApiUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { apiClient } from '../apiClient';
import {
  CreateAuditQuestionResponseRequest,
  CreateAuditQuestionResponseResponse,
  UpdateAuditQuestionResponseRequest,
  UpdateAuditQuestionResponseResponse,
  ListAuditQuestionResponsesRequest,
  ListAuditQuestionResponse,
  GetAuditQuestionResponseRequest,
  GetAuditQuestionResponseResponse,
  DeleteAuditQuestionResponseRequest,
} from 'src/types/helios/QuestionResponse';
import {
  SearchAuditQuestionsRequest,
  SearchAuditQuestionsResponse,
} from 'src/types/helios/SearchAuditQuestions';

export const questionResponseService = {
  // List question responses
  getAll: (data: ListAuditQuestionResponsesRequest) => {
    return apiClient.get<ListAuditQuestionResponse>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.QUESTION_RESPONSES.LIST(
          data.businessUnitId,
          data.auditId,
        ),
      ),
      data,
    );
  },

  // Get question response by ID
  getById: (data: GetAuditQuestionResponseRequest) => {
    return apiClient.get<GetAuditQuestionResponseResponse>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.QUESTION_RESPONSES.GET(
          data.businessUnitId,
          data.auditId,
          data.questionId,
        ),
      ),
    );
  },

  // Create question response
  create: (data: CreateAuditQuestionResponseRequest) => {
    return apiClient.post<
      CreateAuditQuestionResponseResponse,
      CreateAuditQuestionResponseRequest
    >(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.QUESTION_RESPONSES.CREATE(
          data.businessUnitId,
          data.auditId,
        ),
      ),
      data,
    );
  },

  // Update question response
  update: (data: UpdateAuditQuestionResponseRequest) => {
    return apiClient.put<
      UpdateAuditQuestionResponseResponse,
      UpdateAuditQuestionResponseRequest
    >(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.QUESTION_RESPONSES.UPDATE(
          data.businessUnitId,
          data.auditId,
          data.questionId,
        ),
      ),
      data,
    );
  },

  // Delete question response
  delete: (data: DeleteAuditQuestionResponseRequest) => {
    return apiClient.delete(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.QUESTION_RESPONSES.DELETE(
          data.businessUnitId,
          data.auditId,
          data.questionId,
        ),
      ),
    );
  },

  // Search audit questions
  search: (data: SearchAuditQuestionsRequest) => {
    return apiClient.post<SearchAuditQuestionsResponse, SearchAuditQuestionsRequest>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.QUESTION_RESPONSES.SEARCH(
          data.businessUnitId,
          data.auditId,
        ),
      ),
      data,
    );
  },
};
